import { PageLoading } from '@/components/page-loading'
import { Suspense, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { ContentLayout } from '../content-layout'
import { SignTitle, SvgIcon } from '@/components'
import { Modal } from 'antd'
import styled from 'styled-components'

import EndpointSecurityCreate from '@/pages/endpoint-security/create-task'
import EndpointSecurityTask from '@/pages/endpoint-security/task-list'
import EndpointSecurityTaskDetail from '@/pages/endpoint-security/task-detail'
import { t } from '@/i18n'

export const EndpointSecurityLayout = () => {
  const [isShow, setIsShow] = useState(false)

  const menuList = [
    {
      key: 'create',
      label: t('创建任务'),
      component: <EndpointSecurityCreate />,
    },
    {
      key: 'task',
      label: t('任务列表'),
      component: <EndpointSecurityTask />,
    },
    {
      key: 'task',
      label: t('任务详情'),
      component: <EndpointSecurityTaskDetail />,
      show: false,
      name: 'detail',
    },
  ]

  const onShow = () => {
    setIsShow(true)
  }

  const onHide = () => {
    setIsShow(false)
  }

  const rightSlot = (
    <div
      onClick={() => {
        onShow()
      }}
      className="description"
    >
      <SvgIcon name={'场景描述'} width={14} style={{ marginRight: '6px', height: 14 }} />
      <span>{t('场景描述')}</span>
    </div>
  )

  return (
    <>
      <ContentLayout menuList={menuList} rightSlot={rightSlot}>
        <Suspense fallback={<PageLoading />}>
          <Outlet />
        </Suspense>
      </ContentLayout>
      <ModalWrapper
        title={<SignTitle show>{t('场景描述')}</SignTitle>}
        visible={isShow}
        onCancel={onHide}
        footer={null}
        centered
      >
        <div
          className="title"
          style={{
            fontWeight: '500',
            fontSize: '14px',
            color: '#333333',
            marginBottom: '16px',
            marginLeft: '8px',
          }}
        >
          {t('可验证设备类型')}
        </div>
        <div
          className="content"
          style={{
            fontSize: '14px',
            color: '#666666',
            marginBottom: '24px',
            marginLeft: '8px',
          }}
        >
          AV、EDR、HIDS、SOC
        </div>
        <div
          className="title"
          style={{
            fontWeight: '500',
            fontSize: '14px',
            color: '#333333',
            marginBottom: '16px',
            marginLeft: '8px',
          }}
        >
          {t('验证原理')}
        </div>
        <div
          className="content"
          style={{
            fontSize: '14px',
            color: '#666666',
            marginBottom: '24px',
            marginLeft: '8px',
          }}
        >
          {t(
            '由客户端根据安装环境，自动部署依赖和下发模拟攻击向量，执行攻击操作，通过客户端持续监控和分析主机行为，验证设备的安全防御能力。',
          )}
        </div>
        <div
          className="title"
          style={{
            fontWeight: '500',
            fontSize: '14px',
            color: '#333333',
            marginBottom: '16px',
            marginLeft: '8px',
          }}
        >
          {t('使用说明')}
        </div>
        <div
          className="content"
          style={{
            fontSize: '14px',
            color: '#666666',
            marginBottom: '24px',
            marginLeft: '8px',
          }}
        >
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon name={'纸飞机'} width={14} style={{ marginRight: '6px', height: '14px' }} />
            <span>{t('创建任务前需部署客户端')}</span>
          </div>
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon
              name={'纸飞机'}
              width={14}
              height={14}
              style={{ marginRight: '6px', minWidth: '14px' }}
            />

            <span>
              {t(
                '如需完成模拟攻击和验证自动化闭环，可在终端部署日志采集Agent接入 AV/EDR/HIDS/SOC\n              的设备告警日志。',
              )}
            </span>
          </div>
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon
              name={'纸飞机'}
              width={14}
              height={14}
              style={{ marginRight: '6px', minWidth: '14px' }}
            />

            <span>{t('插件参数支持全局配置和单个自定义，单个自定义优先级高于全局配置。')}</span>
          </div>
        </div>
      </ModalWrapper>
    </>
  )
}

const ModalWrapper = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
    position: relative;

    .ant-modal-close {
      width: 36px;
      height: 36px;
      background: #d8d6f4;
      box-shadow: -1px 4px 10px 0px #c7c7c7;
      border-radius: 6px;
      border: none;
      color: #4238c9;
      font-size: 16px;
      font-weight: 500;
      position: absolute;
      right: -8px;
      top: -8px;
      transition: transform 0.3s ease;

      &:hover {
        transform: translate(-18px, 18px);
        box-shadow: 0 0 0 0;
      }

      .ant-modal-close-x {
        width: 100%;
        height: 100%;
        line-height: 36px;
        text-align: center;
      }
    }

    .ant-modal-header {
      height: 56px;
      background: #f2f0ff;
      border-bottom: none;
      margin: 0;
      padding: 19px 20px;
    }
  }
`
